var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHlCertificated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 1H17C16.3054 1 15.6392 1.21758 15.1481 1.60489C14.6569 1.99219 14.381 2.51749 14.381 3.06522V17.9348C14.381 18.4825 14.105 19.0078 13.6139 19.3951C13.1227 19.7824 12.4565 20 11.7619 20",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 14.5833V11.0833",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.08333C15 3.63587 15.2195 4.16577 15.6102 4.55647C16.0009 4.94717 16.5308 5.16667 17.0833 5.16667C17.6359 5.16667 18.1658 4.94717 18.5565 4.55647C18.9472 4.16577 19.1667 3.63587 19.1667 3.08333C19.1667 2.5308 18.9472 2.00089 18.5565 1.61019C18.1658 1.21949 17.6359 1 17.0833 1C16.5308 1 16.0009 1.21949 15.6102 1.61019C15.2195 2.00089 15 2.5308 15 3.08333Z",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 19.5833C12.3642 19.5833 11.8343 19.3638 11.4436 18.9731C11.0529 18.5824 10.8334 18.0525 10.8334 17.5C10.8334 16.9475 11.0529 16.4176 11.4436 16.0269C11.8343 15.6361 12.3642 15.4167 12.9167 15.4167H4.16671C3.61417 15.4167 3.08427 15.6361 2.69357 16.0269C2.30287 16.4176 2.08337 16.9475 2.08337 17.5C2.08337 18.0525 2.30287 18.5824 2.69357 18.9731C3.08427 19.3638 3.61417 19.5833 4.16671 19.5833H12.9167Z",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 8.08328C3.58152 8.08418 3.00654 7.93037 2.5 7.63745V11.8333L4.16667 10.5833L5.83333 11.8333V7.63745C5.32694 7.93074 4.75186 8.08458 4.16667 8.08328Z",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 4.75008C0.833008 5.63414 1.1842 6.48198 1.80932 7.1071C2.43444 7.73223 3.28229 8.08341 4.16634 8.08341C5.0504 8.08341 5.89824 7.73223 6.52336 7.1071C7.14849 6.48198 7.49967 5.63414 7.49967 4.75008C7.49967 3.86603 7.14849 3.01818 6.52336 2.39306C5.89824 1.76794 5.0504 1.41675 4.16634 1.41675C3.28229 1.41675 2.43444 1.76794 1.80932 2.39306C1.1842 3.01818 0.833008 3.86603 0.833008 4.75008Z",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91699 4.75C2.91699 5.08152 3.04869 5.39946 3.28311 5.63388C3.51753 5.8683 3.83547 6 4.16699 6C4.49851 6 4.81646 5.8683 5.05088 5.63388C5.2853 5.39946 5.41699 5.08152 5.41699 4.75C5.41699 4.41848 5.2853 4.10054 5.05088 3.86612C4.81646 3.6317 4.49851 3.5 4.16699 3.5C3.83547 3.5 3.51753 3.6317 3.28311 3.86612C3.04869 4.10054 2.91699 4.41848 2.91699 4.75Z",
    stroke: "#737373",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlCertificated);
export default __webpack_public_path__ + "static/media/HL_Certificated.26adfef0da2c454fbd8390108065bd95.svg";
export { ForwardRef as ReactComponent };